<template>
  <div class="repertory-input-component">
    <div
      @click="show = !show"
      v-if="!selected.length"
      class="d-flex align-items-center cursor"
    >
      <p class="mb-0 flex-fill">Salvar em um repertório</p>
      <button class="btn">
        <i class="icon-arrow_drop_down"></i>
      </button>
    </div>
    <div v-if="show" class="options">
      <div class="new-repertory">
        <div class="row px-lg-3 pl-3 pt-3">
          <div class="col-9">
            <form-group
              id="repertoryName"
              type="text"
              placeholder="Criar novo repertório"
              v-model="rep"
            />
          </div>
          <div class="col-3 pl-0">
            <button
              @click="createRepertory"
              class="btn btn-outline-success w-100"
            >
              Criar
            </button>
          </div>
        </div>
      </div>
      <div class="repertory-list p-3">
        <div v-for="repertory in repertories" :key="repertory.id" class=" repo">
          <div class="d-flex align-items-center my-4">
            <router-link
              :to="{
                name: 'my-repertory-select',
                params: { id: repertory.id }
              }"
              class="flex-fill"
              >{{ repertory.name }}</router-link
            >
            <button
              :class="[wasSaved(repertory) ? 'selected' : 'btn-success']"
              class="btn"
              :disabled="wasSaved(repertory)"
              @click="saveMusic(repertory)"
            >
              <loading :show="isLoading" />
              <template v-if="!isLoading">
                <span v-if="wasSaved(repertory)"
                  >Salvo <i class="icon-checkmark ml-1"></i
                ></span>
                <span v-else>Salvar</span>
              </template>
            </button>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      selected: "",
      show: false,
      isLoading: false,
      rep: ""
    };
  },
  props: {
    music: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("repertories", ["repertories"])
  },
  mounted() {
    this.dispatchRepertories();
  },
  methods: {
    dispatchRepertories() {
      this.$store
        .dispatch("repertories/getRepertories", {
          id: this.$user.user.id
        })
        .then()
        .finally(() => {
          this.loading = false;
          this.isLoading = false;
        });
    },
    wasSaved(r) {
      for (let i in r.musics) {
        if (r.musics[i].music.id == this.music.id) {
          return true;
        }
      }
      return false;
    },
    saveMusic(r) {
      let ids = r.musics.map(c => c.music.id);
      ids.push(this.music.id);
      this.isLoading = true;
      this.$store
        .dispatch("repertories/updateMyRepertory", {
          id: r.id,
          musics: ids,
          user: this.$user.user.id
        })
        .then()
        .finally(() => {
          this.dispatchRepertories();
        });
    },
    createRepertory() {
      if (this.rep.length) {
        this.$store
          .dispatch("repertories/createNewRepertory", {
            user: this.$user?.user?.id,
            name: this.rep
          })
          .then(() => {
            this.$message.success("Repertório criado com sucesso");
            this.dispatchRepertories();
          })
          .catch(() => {
            this.$message.error("Não foi possível criar um novo repertório.");
          });
      } else {
        this.$message.warning("Escolha um nome para o repertorio");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.repertory-input-component {
  ::v-deep i {
    color: #6b9b7e;
  }

  .cursor {
    cursor: pointer;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 130%;
    color: #6b9b7e;
  }

  a {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 130%;
    color: #ffffff;
  }

  .options {
    width: 100%;
    top: 0;
    height: 80%;
    left: 0;
    position: absolute;
    z-index: 999;
    background: linear-gradient(
        0deg,
        rgba(45, 181, 99, 0.16),
        rgba(45, 181, 99, 0.16)
      ),
      #111112;
    box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.8);
    border-radius: 8px;

    .new-repertory {
      background: linear-gradient(
          0deg,
          rgba(45, 181, 99, 0.16),
          rgba(45, 181, 99, 0.16)
        ),
        #111112;
      box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.3);
      border-radius: 8px 8px 0 0;
    }

    .repertory-list {
      overflow-y: scroll;
      max-height: 70%;
      &::-webkit-scrollbar {
        width: 12px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #111112;
        border-radius: 6px;
      }

      .btn {
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 130%;
        color: #ffffff;

        @media screen and (min-width: 992px) {
          display: none;
        }
      }

      .btn-success {
        @media screen and (max-width: 992px) {
          background: transparent;
          border: 1px solid #2db563;
        }
      }

      .selected {
        background: #4b5058;
        border-radius: 6px;

        i {
          color: #ffffff;
        }
      }

      .repo {
        &:hover {
          .btn {
            display: block;
          }
        }
        .line {
          width: 100%;
          background: #020204;
          height: 2px;
        }
      }
    }
  }
}
</style>
